export default __webpack_public_path__ + "static/media/010.64713704.png";